import { render } from "./CreateVMFromBackup.vue?vue&type=template&id=7865b60d&scoped=true"
import script from "./CreateVMFromBackup.vue?vue&type=script&lang=js"
export * from "./CreateVMFromBackup.vue?vue&type=script&lang=js"

import "./CreateVMFromBackup.vue?vue&type=style&index=0&id=7865b60d&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7865b60d"]])

export default __exports__